<script>
  import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from 'sveltestrap';

  export let open, mode, statusMessage;
</script>

<Modal isOpen={open} toggle={() => (open = !open)}>
  <ModalHeader toggle={() => (open = !open)}
    >{`${
      mode == 'order' ? 'Order' : 'Approval'
    } Concern Notification`}</ModalHeader
  >
  <ModalBody>{@html statusMessage}</ModalBody>
  <ModalFooter>
    <Button color="danger" on:click={() => (open = !open)}>Close</Button>
  </ModalFooter>
</Modal>
